// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"88d01d40","456":"3a84694c","656":"69c629b3","756":"13734106","968":"b775dc46"}[chunkId] + ".chunk.js";
};